import './pdf_reportOrder.css';
import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import reportService from "../../features/report/reportService";
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import moment from "moment";
import _ from 'lodash';

function PDFReportOrder() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // Retrieve specific query parameters  
    const districtId = queryParams.get('districtId');
    const authorization = queryParams.get('token');

    let [reportOrderDataWeb, setReportOrderDataWeb] = useState([]);
    let [reportSchoolName, setReportSchoolName] = useState([]);
    const [distName, setDistName] = useState('');
    let [isPageLoad, setisPageLoad] = useState(false);
    let [isLoading, setIsLoading] = useState(false);

    // let uniqueUsersByID

    useEffect(() => {
        setIsLoading(true);
        reportService.getReportPageDatePDF({ districtId: districtId }, authorization).then((response) => {
            setDistName(response.data.distName)
            setReportOrderDataWeb(response.data);
            console.log(response.data)
            setIsLoading(false)
            setisPageLoad(true)
        }).catch(err => {
            toast.error(err.message ? err.message : "Unable to fetch enrollment data.");
        })
    }, []);

    //New Code Added **START
    let CombinedSchoolrptdata = [];
    let CombinedSchoolrptdataFinal = [];
    let modifiedData = _.map(reportOrderDataWeb.schoolReportData, (value, key, object) => {
        _.map(value["schoolRepDataArr"], (value1, key1, object1) => {
            value1["ParentName"] = value["name"];
            CombinedSchoolrptdata.push(value1);
        });
    });
    _.map(CombinedSchoolrptdata, (value, key, object) => {
        value["P1"] = 0;
        value["P2"] = 0;
        value["P3"] = 0;
        value["P4"] = 0;
        let temp = _.filter(CombinedSchoolrptdata, {
            name: value.name
        });
        let mainData = _.filter(temp, (value, key, object) => {
            return (_.find(value["reportSchoolData"], { "value": 1 }));
        });
        if (mainData.length > 0) {
            let temp1 = {};
            _.map(mainData, (v, k) => {
                if (k == 0) {
                    temp1 = _.cloneDeep(v);
                }
                switch (v["ParentName"]) {
                    case 'Elementary Survey':
                        temp1["P1"] = 1;
                        break;
                    case 'Secondary School':
                        temp1["P2"] = 1;
                        break;
                    case 'Staff Survey':
                        temp1["P3"] = 1;
                        break;
                    case 'Parent Survey':
                        temp1["P4"] = 1;
                        break;
                    default:
                        break;
                }
                CombinedSchoolrptdataFinal.push(temp1);
            });
        } else {
            CombinedSchoolrptdataFinal = _.concat(CombinedSchoolrptdataFinal, temp);
        }
    });
    CombinedSchoolrptdataFinal = _.uniqBy(CombinedSchoolrptdataFinal, "schoolId");
    console.log(CombinedSchoolrptdataFinal);

//New Code Added **END


    const convertDate = (dateStr) => {
        return moment(dateStr).format('MM/YY');
    }

    const renderTableStructure = () => {
        const itemsPerPage = 20;
        const numPages = Math.ceil(CombinedSchoolrptdataFinal.length / itemsPerPage);
 
        return (
            <div>
                {Array.from({ length: numPages }).map((_, pageIndex) => (
                    <Table sx={{ minWidth: 650 }} >
                        <TableHead className={itemsPerPage > 20 ? "page-break pdfreportmail_setHeaderbackground" : "pdfreportmail_setHeaderbackground"}>
                        <TableRow sx={{ padding: '15px' }}>
                            <TableCell align="left" sx={{fontSize: '15px', fontWeight: 'bold'}} ref={el => {
                                 if (el) {
                                   el.style.setProperty('width', '30%', 'important');
                                 }
                               }}>School Name</TableCell>
                            <TableCell align="left" sx={{fontSize: '15px', fontWeight: 'bold'}} ref={el => {
                                 if (el) {
                                   el.style.setProperty('width', '20%', 'important');
                                 }
                               }}>CDS Code </TableCell>
                            <TableCell align="left" sx={{fontSize: '15px', fontWeight: 'bold', lineHeight: 1.2, padding:'15px'}}>Elementary CHKS <br/>Report</TableCell>
                            <TableCell align='left' sx={{fontSize: '15px', fontWeight: 'bold', lineHeight: 1.2, padding:'15px'}}>Secondary CHKS <br/> Report</TableCell>
                            <TableCell align='left' sx={{fontSize: '15px', fontWeight: 'bold', lineHeight: 1.2, padding:'15px'}}>CSSS <br/>Report</TableCell>
                            <TableCell align='left' sx={{fontSize: '15px', fontWeight: 'bold', lineHeight: 1.2, padding:'15px'}}>CSPS <br/>Report</TableCell>                 
                        </TableRow>
                        </TableHead>
                        <TableBody className="pdfreport_setBodybackground">
                        {CombinedSchoolrptdataFinal.slice(pageIndex * itemsPerPage, (pageIndex + 1) * itemsPerPage).map((report, index) => (
                            <TableRowStyledReportWebPdf key={index}>
                                 <TableCell className='report_contextText' sx={{fontSize: '16px'}}>{report.name}</TableCell>
                                 <TableCell className='imageCell' sx={{fontSize: '16px'}}>{report.ncesId}</TableCell>
                                 <TableCell className='imageCell'>
                                     {report.P1 == 1 ?
                                         <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck.png')} alt='Distric Check'></img>
                                         : ''}
                                 </TableCell>
                                 <TableCell className='imageCell'>
                                     {report.P2 == 1  ?
                                         <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck.png')} alt='Distric Check'></img>
                                         : ''}
                                 </TableCell>
                                 <TableCell className='imageCell'>
                                     {report.P3 == 1  ?
                                         <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck.png')} alt='Distric Check'></img>
                                         : ''}
                                 </TableCell>
                                 <TableCell className='imageCell'>
                                     {report.P4 == 1  ?
                                         <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck.png')} alt='Distric Check'></img>
                                         : ''}
                                 </TableCell>
                            </TableRowStyledReportWebPdf>
                        ))}
                        </TableBody>
                    </Table>
                    // </div>
                ))}
            </div>
        );
    };


    const TableRowStyledReportWebPdf = styled(TableRow)`
        &:nth-of-type(odd) {
            background-color: #f6f6f6;
            font-size: 14px;
        }
        &:nth-of-type(even) {
            background-color: #fff;
            font-size: 14px;
        }
    `;

    return (
        <>
            <div className='pdfreportmail_pageHeader'>
                <div id="pdfImage"><img alt="Delete School" src={require("../../assets/images/menuHeader.png")} className="pdfreportmail_logoSize"></img></div>
                <div className="pdfreportmail_ImageSub">CalSCHLS Coordinator Portal</div>
                <div className='report_orderFormText'>REPORT ORDER FORM</div>
                <div className="pdfreportmail_country">{distName}</div>
                <div className="pdfreportmail_subTitle">DISTRICT REPORT</div>
            </div>
            <div className='pdfreportmail_pageContent'>
                <div className='pdfreportmail_userTable'>
                    <TableContainer component={Paper} className="pdfOrder_tableStyle">
                        <Table sx={{ minWidth: 700, padding: '20px' }} aria-label="simple table">
                            <TableHead className="pdfreportmail_setHeaderbackground">
                                <TableRow>
                                    <TableCell align="left" sx={{fontSize: '15px', fontWeight: 'bold'}}>Survey</TableCell>
                                    <TableCell align="left" sx={{fontSize: '15px', fontWeight: 'bold'}}>Data Dashboard </TableCell>
                                    <TableCell align="left" sx={{fontSize: '15px', fontWeight: 'bold'}}>District Raw Dataset</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className="pdfreport_setBodybackground">
                                {reportOrderDataWeb.distReportData && reportOrderDataWeb.distReportData.map((data, key) => (
                                    <TableRowStyledReportWebPdf>
                                        <TableCell sx={{fontSize: '16px'}} >{data.surveyName}</TableCell>
                                        <TableCell className='imageCell'>
                                            {reportOrderDataWeb.subscriptionStartDate ?
                                                <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck.png')} alt='Distric Check'></img>
                                                : ''
                                            }
                                        </TableCell>
                                        <TableCell className='imageCell'>
                                            {data.distReportData[0].value == 1 ?
                                                <img className='imageCheckreportPdf' src={require('../../assets/images/surveyCheck.png')} alt='Distric Check'></img>
                                                : ''}
                                        </TableCell>
                                    </TableRowStyledReportWebPdf>
                                ))}
                             </TableBody>
                        </Table>
                       {reportOrderDataWeb.subscriptionEndDate ? <div className='reportNote'>Note: Data Dashboard expires {convertDate(reportOrderDataWeb.subscriptionEndDate)}</div> : ''}
                        <div className='pdfreportmail_subTitle'>SCHOOL REPORT</div>                
                            { renderTableStructure() }
                    </TableContainer>

                </div>
            </div>
            {isPageLoad ? <div id="pageload" ></div> : ''}
        </>
    )
}

export default PDFReportOrder